<div class="component-wrapper">
  <div class="modal-container">
    <h1>404</h1>
    <div class="text-container">
      <h2>Oops!</h2>
      <p class="message">Sorry but the page you are looking for does not exist or was removed</p>
    </div>
    <button routerLink="/login">Go To Homepage</button>
  </div>
</div>
